module.exports = __webpack_public_path__ + "static/img/YD20.0df823f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YD20.png
// module id = Pey+
// module chunks = 2